module.exports = __webpack_public_path__ + "img/pic25.9951b6cc.png";